import type { UiFeaturePolicy } from '../types/uiAccessPolicy';

export const UI_FEATURE_POLICY_CONFIG_KEY = 'ui_feature_policies';

export const DEFAULT_UI_FEATURE_POLICY: UiFeaturePolicy = {
  version: 1,
  features: {
    'patient_visit.diagnosis_section': {
      enabledByDefault: true,
      allowedConfigIds: [],
      deniedConfigIds: [],
      allowedUserIds: [],
      allowedRoles: [],
    },
    'patient_visit.glucose_log': {
      enabledByDefault: true,
      allowedConfigIds: [],
      deniedConfigIds: [],
      allowedUserIds: [],
      allowedRoles: [],
    },
  },
};
